<h1 mat-dialog-title>Add Student</h1>
<form [formGroup]="studentForm" (ngSubmit)="submit(studentForm)">
    <mat-dialog-content>
        <p>For a student to be eligible for this tool, their application must be completed, but not have selected this scholarship.</p>
        <p>Note: If this tool is used, any additional questions the scholarship might have required will be left blank.</p>
        <p class="mb-0">Enter the Student ID</p>
        <mat-form-field>
            <mat-label>Student ID</mat-label>
            <input matInput formControlName="studentID" required>
            @if (studentForm.get('studentID').hasError('required')) {
            <mat-error>response required</mat-error>
            }
            @if (studentForm.get('studentID').hasError('invalid')) {
            <mat-error>student invalid</mat-error>
            }
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-raised-button type="button" (click)="closeDialog()">Cancel</button>
        <button mat-flat-button type="submit">Submit</button>
    </mat-dialog-actions>
</form>